import { useRouter } from "next/router";
import { useState } from "react";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";

function Descriptions({ t, description, attributes, returnPolicy }) {
  const { locale } = useRouter();

  const excluded_indexed_attributes = [
    "price",
    "aps_sub_interval",
    "url_key",
    "image",
    "name",
    "fast_delivery",
    "short_description",
    "eligible_for_tabby",
    "eligible_for_tamara",
    "apply_voucher",
    "tax_class_id",
    "status",
  ];

  let specification;

  if (attributes) {
    specification = Object.entries(attributes || {})
      ?.map(([key, obj]) => ({ code: key, ...obj }))
      ?.filter((attr) => {
        return !excluded_indexed_attributes?.includes(attr.code);
      });
  }
  const [active, setActive] = useState(specification ? "spec" : "desc");
  const tabs = {
    spec: { title: "Specifications", selector: "spec", content: specification },
    desc: {
      title: "ProductDescription",
      selector: "desc",
      content: description,
    },
    policy: {
      title: "ReturnPolicy",
      selector: "policy",
      content: returnPolicy,
    },
  };
  console.log("attributes_________", { tabs, active });
  const checkifNoContent = Object.values(tabs).every(
    (item) => item.content === null
  );

  return (
    <div
      className={`p-4 max-[768px]:p-2 rounded-xl ${
        checkifNoContent ? "" : "border"
      } my-10 bg-white p-2 rounded-md`}
    >
      <div className="flex">
        <ul className="w-1/4 max-[991px]:w-1/3 max-[768px]:w-full">
          {Object.values(tabs).map(({ selector, title, content }) => {
            return (
              content && (
                <li
                  onClick={() => selector !== active && setActive(selector)}
                  key={selector}
                  className={`text-center max-[768px]:text-left  rounded-md cursor-pointer mb-2 py-4 px-6 ${
                    active === selector
                      ? "text-lightblue bg-gray-100"
                      : "bg-gray-200"
                  }`}
                >
                  <div className="font-semibold max-[768px]:flex max-[768px]:items-center max-[768px]:justify-between">
                    <span>{t(title)}</span>
                    <MdOutlineKeyboardArrowDown
                      size="22px"
                      className={`hidden max-[768px]:block ${
                        selector === active
                          ? "rotate-180 duration-300 transition-all"
                          : "rotate-0"
                      }`}
                    />
                  </div>
                  <div
                    className={`hidden ${
                      active === selector && "max-[768px]:block mt-2"
                    }`}
                  >
                    {content && active !== "spec" ? (
                      <p
                        className="font-medium text-gray-900"
                        dangerouslySetInnerHTML={{
                          __html: content,
                        }}
                      />
                    ) : content && active === "spec" ? (
                      content?.map((spec, i) => (
                        <div
                          className={`grid grid-cols-2 ${
                            locale === "ar" ? "text-right" : "text-left"
                          } text-black`}
                          key={i}
                        >
                          <div
                            className={`${
                              !(i % 2) ? "bg-gray-200" : "bg-white"
                            } px-2 py-1 rounded-sm`}
                          >
                            {spec?.attribute_label ||
                              spec?.[locale == "ar" ? "14" : "2"]?.label}
                          </div>
                          <div
                            className={`${
                              !(i % 2) ? "bg-gray-200" : "bg-white"
                            } p-2 rounded-sm`}
                          >
                            {spec?.value?.label ||
                              spec?.[locale == "ar" ? "14" : "2"]?.value}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="flex items-center justify-center h-full p-8 text-lg text-gray-400">
                        {t("NoData")}
                      </div>
                    )}
                  </div>
                </li>
              )
            );
          })}
        </ul>

        <div className="flex-1 px-5 max-[768px]:hidden">
          {active !== "spec" && tabs[active] && tabs[active].content ? (
            <p
              className="font-medium text-gray-900"
              dangerouslySetInnerHTML={{
                __html: tabs[active].content,
              }}
            />
          ) : (
            active === "spec" &&
            specification?.map((spec, i) => {
              if (
                !!spec["2"] &&
                spec["2"]?.value !== false &&
                spec["14"]?.value !== false
              ) {
                return (
                  <div className="grid grid-cols-2" key={i}>
                    <div
                      className={`${
                        !(i % 2) ? "bg-gray-200" : "bg-white"
                      } px-4 py-2 rounded-sm`}
                    >
                      {locale === "en" ? spec["2"]?.label : spec["14"]?.label}
                    </div>
                    <div
                      className={`${
                        !(i % 2) ? "bg-gray-200" : "bg-white"
                      } px-4 py-2 rounded-sm`}
                    >
                      {locale === "en" ? spec["2"]?.value : spec["14"]?.value}
                    </div>
                  </div>
                );
              }
            })
          )}
        </div>
      </div>
    </div>
  );
}

export default Descriptions;
